import { ref } from 'vue'

// DTA-1036: lets a page outside the cart (the athletics "Pay fee now") open the
// cart's checkout modal for one district. The cart popover mounts its Cart
// components lazily, so this is state the Cart reads when it mounts, not an
// event it could miss. Not persisted: a reload never reopens checkout.
export const checkoutRequestDistrictId = ref<number | null>(null)

export const requestCheckout = (districtId: number) => {
  checkoutRequestDistrictId.value = districtId
  window.dispatchEvent(new CustomEvent('open-cart'))
}
